var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"col-12 max-width-4 mx-auto my2 px3 center"},[_c('div',{staticClass:"border-top border-gray-4"},_vm._l((_vm.phrases),function(phrase){return _c('ListPhraseItem',{key:(phrase.company ? '##' : '#') + phrase.hashtag,attrs:{"phrase":phrase,"chat":_vm.chat}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }